import React from "react";
import "../assets/scss/custom/pills.scss"

type Value={
    name:string;
    id:string;
}

interface PillsProps{
    allValues:object,
    handleClose:(payload:any)=>void
}

const Pills = (props:PillsProps) => {
    return(
    <>
        {Object.values(props.allValues).map((opt:Value) => {
            return(
                <div key={opt.id} className="pill-chip">
                    <span className="m-1">{opt.name}</span>
                    <div className="cursor-pointer  material-symbols-outlined fs-18" onClick={() => props.handleClose(opt)}>
                        close
                    </div>
                </div>
            )
        })}
    </>
    )
}

    


export default Pills;